import { cva, cx } from '@vizit/theme';
import React from 'react';

type CardStatus = 'default' | 'success' | 'gradient';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The status of the card
   * success: adds a green border and a checkmark icon (when Card.StatusIcon is also a child of the card)
   * other statuses are not yet implemented
   *
   * @type 'default' | 'success' | 'gradient'
   * @default 'default'
   */
  status?: CardStatus;
}

const classes = {
  root: cva({
    base: 'w-full bg-primary shadow-xs relative @container',
    variants: {
      status: {
        default: 'border border-secondary',
        success: 'border border-success-primary',
        gradient: cx(
          'p-1 bg-gradient-linear-12-border',
          'before:content-[""] before:absolute before:inset-1 before:bg-primary',
        ),
      },
    },
  }),
};

const CardLevelContext = React.createContext<CardProps['status']>('default');

function Card(props: CardProps) {
  const { children, className, status = 'default', ...rest } = props;

  return (
    <CardLevelContext.Provider value={status}>
      <div className={cx(classes.root({ status }), className)} {...rest}>
        {children}
      </div>
    </CardLevelContext.Provider>
  );
}

export type { CardStatus, CardProps };
export { Card, CardLevelContext };
